import { QuestionCheckbox, type IQuestionCheckbox } from './question-checkbox';

export interface IQuestionCollapseCheckbox extends IQuestionCheckbox {}

export class QuestionCollapseCheckbox
  extends QuestionCheckbox
  implements IQuestionCollapseCheckbox
{
  public indeterminate = false;

  constructor(options: IQuestionCollapseCheckbox) {
    super(options);

    this.elementType = 'collapseCheckbox';
    this.size = 0;
  }
}
